/**
 * i18n Configuration
 *
 * Internationalization setup for VitaHub supporting English, German, and
 * Brazilian Portuguese. Uses i18next with browser language detection and
 * localStorage persistence.
 *
 * Supported languages are defined in `./supported.js` — never add a new
 * language here without updating that file.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import de from './locales/de.json'
import en from './locales/en.json'
import ptBR from './locales/pt-BR.json'
import { SUPPORTED_LANGUAGES } from './supported'

const resources = {
  de: { translation: de },
  en: { translation: en },
  'pt-BR': { translation: ptBR }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',  // Fall back to English when a key is missing
    supportedLngs: SUPPORTED_LANGUAGES,

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'vitahub-language'
    },

    interpolation: {
      escapeValue: false  // React already escapes
    },

    react: {
      useSuspense: false  // Disable suspense for better UX
    }
  })

export default i18n
